import 'css-chunksrc/client/scenes/projectsTransfer/loader/styles.scss';export default {
  "loader": "_loader_x8zo5_1",
  "name": "_name_x8zo5_8",
  "avatar": "_avatar_x8zo5_13",
  "label": "_label_x8zo5_21",
  "zone": "_zone_x8zo5_30"
};